import { useParams } from 'react-router';

import { useI18n } from '@app-velocity/i18n';

import { MessageBus } from '@app-velocity/message-bus';
import { useCurrentUser } from '@app-velocity/libs/auth';

import { Button } from '@app-velocity/ui';
import { useReportContext } from '@app-velocity/libs/report';

const messageBus = new MessageBus('reports');

export type ShareReportButtonProps = {
  prototypeId: string;
  workspaceId: string;
};

export const ShareReportButton = ({
  prototypeId,
  workspaceId,
}: ShareReportButtonProps) => {
  const { shareToken } = useParams<{ shareToken: string }>();
  const { t } = useI18n();
  const currentUser = useCurrentUser();
  const { reportURL } = useReportContext();

  const openShareReportModal = () => {
    messageBus.publish('modal:share-figma-report:open', {
      link: reportURL,
      prototypeId,
      workspaceId,
      shareToken,
    });
  };

  if (!currentUser?.authorized) return null;

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      onClick={openShareReportModal}
    >
      {t('reports:share_report')}
    </Button>
  );
};
